export const STATS_TEXT = {
  en: {
    title: "Our Food Community", description: "Discover the people and meals on What To Eat?",
    clients: "Registered Clients", providers: "Active Food Providers", menu: "Active Menu Items",
    loading: "Loading live totals...", live: "Live totals - updated automatically.",
    cached: "Saved totals - waiting for a live connection.",
    stale: "Live updates unavailable. Showing last received totals.",
    error: "Live totals are temporarily unavailable. Please retry.",
    offline: "Offline - connect to load totals.", offlineSaved: "Offline - showing last received totals.",
    retry: "Retry loading totals"
  },
  es: {
    title: "Nuestra comunidad gastronómica", description: "Descubre las personas y comidas de What To Eat?",
    clients: "Clientes registrados", providers: "Proveedores activos", menu: "Platos activos",
    loading: "Cargando totales en vivo...", live: "Totales en vivo - actualización automática.",
    cached: "Totales guardados - esperando conexión.",
    stale: "Actualizaciones no disponibles. Mostrando los últimos totales.",
    error: "Totales no disponibles temporalmente. Inténtalo de nuevo.",
    offline: "Sin conexión - conéctate para cargar totales.", offlineSaved: "Sin conexión - mostrando los últimos totales.",
    retry: "Reintentar"
  },
  fr: {
    title: "Notre communauté culinaire", description: "Découvrez les personnes et les plats sur What To Eat?",
    clients: "Clients inscrits", providers: "Prestataires actifs", menu: "Plats actifs",
    loading: "Chargement des totaux...", live: "Totaux en direct - mise à jour automatique.",
    cached: "Totaux enregistrés - en attente de connexion.",
    stale: "Mises à jour indisponibles. Derniers totaux affichés.",
    error: "Totaux temporairement indisponibles. Réessayez.",
    offline: "Hors ligne - connectez-vous pour charger les totaux.", offlineSaved: "Hors ligne - derniers totaux affichés.",
    retry: "Réessayer"
  },
  de: {
    title: "Unsere Food-Community", description: "Entdecke Menschen und Mahlzeiten auf What To Eat?",
    clients: "Registrierte Kunden", providers: "Aktive Anbieter", menu: "Aktive Menüpunkte",
    loading: "Live-Zahlen werden geladen...", live: "Live-Zahlen - automatische Aktualisierung.",
    cached: "Gespeicherte Zahlen - Verbindung wird hergestellt.",
    stale: "Live-Updates nicht verfügbar. Letzte Zahlen werden angezeigt.",
    error: "Zahlen vorübergehend nicht verfügbar. Bitte erneut versuchen.",
    offline: "Offline - zum Laden bitte verbinden.", offlineSaved: "Offline - letzte Zahlen werden angezeigt.",
    retry: "Erneut versuchen"
  },
  pt: {
    title: "Nossa comunidade gastronômica", description: "Descubra pessoas e refeições no What To Eat?",
    clients: "Clientes registrados", providers: "Fornecedores ativos", menu: "Itens ativos",
    loading: "Carregando totais...", live: "Totais ao vivo - atualização automática.",
    cached: "Totais salvos - aguardando conexão.",
    stale: "Atualizações indisponíveis. Exibindo os últimos totais.",
    error: "Totais temporariamente indisponíveis. Tente novamente.",
    offline: "Sem conexão - conecte-se para carregar totais.", offlineSaved: "Sem conexão - exibindo os últimos totais.",
    retry: "Tentar novamente"
  }
};

export function validateMarketplaceTotals(totals) {
  if (!totals || !["clientCount", "providerCount", "menuItemCount"].every(
    (key) => Number.isSafeInteger(totals[key]) && totals[key] >= 0
  )) throw new Error("Invalid marketplace totals.");
  return totals;
}
